module.exports = __webpack_public_path__ + "img/1512617168.8f7b0d74.jpg";